<template>
  <div class="reset_password_dialog">
    <el-dialog
      :title="$t('lang.温馨提示')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="$i18n.locale == 'zh-CN' ? '628px' : '700px'"
    >
      <div class="content">
        {{ $t("lang.第一次登录用户为了您的帐户安全请先重置您的登录密码") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onClickTrue">{{
          $t("lang.前往重置")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    //#region 按钮点击事件
    onClickTrue() {
      this.dialogVisible = false;
      this.$emit("onResetPwd");
    },
    //#endregion
  },
};
</script>

<style lang="less" scoped>
.reset_password_dialog {
  .content {
    display: flex;
    justify-content: center;
    margin: 5px 115px;
    font-size: 17px;
    color: #333;
  }
  /deep/ .el-dialog {
    width: 628px;
  }
  /deep/ .el-dialog__footer {
    padding: 0 24px 24px 0;
  }
  /deep/ .el-button + .el-button {
    margin-left: 24px;
  }
  /deep/ .el-dialog__header {
    padding: 24px 0 0 45px;
    font-size: 18px;
  }
  /deep/ .el-dialog__headerbtn {
    margin-top: 5px;
  }
}
.dialog-footer /deep/ .el-button--medium {
  padding: 12px 20px;
}
</style>
